import css from './newstile.scss?inline';
import globalStyles from '../../index.scss?inline';	
import { ArgSpecDictionary, TypedVars } from "../component-utils";

const DEBUG_VERBOSE: boolean  = false;
const CLASS_NAME: string = 'HHDSNewsTile';
const TAG_NAME: string = 'hhds-newstile';
export const HHDSNewsTileTagName: string = TAG_NAME;

// ////////////////////////////////////////////////////////////////////

export class HHDSNewsTile extends HTMLElement {

  private vars: TypedVars = new TypedVars(this);
	private shadow: ShadowRoot;	

	constructor() {
		super();
		DEBUG_VERBOSE && console.log(CLASS_NAME, 'constructed');

		this.shadow = this.attachShadow({ mode: 'open' });
		if (!this.shadow) {
			return;
		}

	}

	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// Lifecycle Methods
	// https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_custom_elements#using_the_lifecycle_callbacks

	// Invoked each time the custom element is appended into a document-connected element.
  connectedCallback() {

		this.parseAttributes();

		this.render();

		DEBUG_VERBOSE && console.log(`[${TAG_NAME}] Initialised`);
	}

  parseAttributes() {
	  this.vars.parse(this, ArgSpecs);
	  console.log(this.vars);
	}

	render() {
    	const date = this.vars.get<string>("date"),
			  title = this.vars.get<string>("title"),
    		  url = this.vars.get<string>("url"),
    		  target = this.vars.get<string>("target");

		this.shadow.innerHTML = `
			<style>${globalStyles}</style>
			<style>${css}</style>
			<a href="${url}" target="${target}">
				<div class="hhds-newstile">
					<p class="hhds-newstile__date link">${date}</p>	

					
						<h3 class="heading heading--sans-01">${title}</h3>
				

					<hhds-link class="link" href="${url}" target="${target}">
						<hhds-icon type="arrowright" slot="end"></hhds-icon>
						READ MORE</hhds-link>
				</div>
			</a>
		`;
	}

	// Invoked each time the custom element is disconnected from the document's DOM.
	disconnectedCallback() {}

	// Invoked each time the custom element is moved to a new document.
	adoptedCallback() {}

	// Invoked each time one of the custom element's attributes is added, removed, or changed.
	attributeChangedCallback() {}

}

export const ArgSpecs: ArgSpecDictionary = {
  "date": {
    description: "The date to display in the tile. This can be used for any text in the date style, such as is the case on the Community Category grid).",
    defaultValue: "",
    type: String,
  },
  "title": {
    description: "News article title.",
    defaultValue: "",
    type: String,
  },
  "url": {
    description: "An optional URL to navigate to when the item is clicked.",
    defaultValue: "",
    type: String,
  },
  "target": {
    description: "Specifies where to open the URL (e.g., _blank for a new tab) if a URL is defined.",
    defaultValue: "",
    type: String,
  },
};

